import { h, Fragment } from 'preact'
import { useLayoutEffect } from 'preact/hooks'

export const PrefooterSeo = ({ title, columns }) => {
   useLayoutEffect(() => {
      let observer = null

      const insertSeoFooter = () => {
         const sitemap = document.getElementById('o-footer-sitemap')
         const accesDirect = document.getElementById('o-footer-acces-direct')
         const accesDirectOld = document.getElementById('o-footer-accesDirect') // a supprimer quand renov elco footer done
         const target = sitemap || accesDirect || accesDirectOld

         if (target) {
            if (observer) observer.disconnect()
            const prefooterSeo = document.getElementById('prefooterSeo')
            if (sitemap) {
               sitemap.parentNode.insertBefore(prefooterSeo, sitemap.nextSibling)
            } else if (accesDirect) {
               accesDirect.parentNode.insertBefore(prefooterSeo, accesDirect)
            } else if (accesDirectOld) {
               accesDirectOld.parentNode.insertBefore(prefooterSeo, accesDirectOld) // a supprimer quand renov elco footer done
            }
            prefooterSeo.classList.remove('d-none')
         }
      }

      const observeFooterWrapper = (footerWrapper) => {
         observer = new MutationObserver(insertSeoFooter)
         observer.observe(footerWrapper, { subtree: true, childList: true })
      }

      const isFooterReady =
         document.getElementById('o-footer-sitemap') !== null ||
         document.getElementById('o-footer-acces-direct') !== null

      if (isFooterReady) {
         insertSeoFooter()
      } else {
         const footerWrapper = document.getElementById('o-footer-wrapper')
         if (footerWrapper) {
            observeFooterWrapper(footerWrapper)
         } else {
            // o-footer-wrapper pas encore dans le DOM, on observe le body pour détecter son arrivée
            observer = new MutationObserver(() => {
               const wrapper = document.getElementById('o-footer-wrapper')
               if (wrapper) {
                  observer.disconnect()
                  observeFooterWrapper(wrapper)
               }
            })
            observer.observe(document.body, { childList: true })
         }
      }

      return () => {
         if (observer) observer.disconnect()
      }
   }, [])

   return (
      <div id="prefooterSeo" class="prefooter o-footer-sitemap o-marge d-none">
         <div class="o-footer-content">
            <div>
               <h3 class="prefooter-title m-0 lead font-weight-bold pt-1">{title}</h3>
               <ul class="categories">
                  {columns.map((item) => {
                     return (
                        <Fragment>
                           {item.map((link) => {
                              return (
                                 <li>
                                    <a href={link.URL}>{link.label}</a>
                                 </li>
                              )
                           })}
                        </Fragment>
                     )
                  })}
               </ul>
            </div>
         </div>
      </div>
   )
}
